<template>
  <div>
    <FormCard
      v-model="invoice"
      :add-custom-button="true"
      create-button-text="Create and Send"
      create-button-class="ihjoz-button-tall"
      :cancel-enabled="false"
      @formSubmit="submitForm($event)"
      @submitClicked="submitClicked($event)">
      <template #additionalButtons>
        <button
          type="button"
          name="cancel"
          class="btn btn-info ihjoz-button ihjoz-button-tall"
          @click="confirm($event)">
          Cancel
        </button>
        <button
          type="button"
          name="Save as Draft"
          class="btn btn-info ihjoz-button ihjoz-button-tall"
          @click="toggleCreateAndSend($event)">
          Save as Draft
        </button>
      </template>
      <input ref="invoiceStatus" type="hidden" name="invoice[status]">
      <input type="hidden" name="invoice[resource_id]" :value="invoiceResourceId">
      <input type="hidden" name="invoice[document_title]" :value="voucherTemplate.document_title">
      <CardForm
        :resource="invoice"
        :show-title="false"
        resource-name="invoice">
        <label class="custom-form-group-label">Customer</label>
        <div v-if="selectedCustomer" class="selected-model">
          <div class="selected-model-header px-i">
            <router-link :to="{ name: 'Edit Customer', params: {
                           id: selectedCustomer.id }
                         }"
                         class="selected-model-header-start">
              <i class="demo-icon" :class="customerIcon(selectedCustomer.account_type)" />
              <span class="selected-model-header-start-text">
                {{ selectedCustomer.display_name }}
              </span>
            </router-link>
            <div class="selected-model-header-end" @click="clearSelectedCustomer()">
              <i class="demo-icon icon-times" />
            </div>
          </div>
          <div class="selected-model-body px-i">
            <div class="model-info-table">
              <div class="model-info-table-cell col-24 col-md-12">
                <h4 class="model-info-table-cell-title">
                  BILLING ADDRESS
                </h4>
                <h4 class="model-info-table-cell-subtitle">
                  {{ selectedCustomer.display_name }}
                </h4>
                <p class="model-info-table-cell-text model-info-table-cell-text-normal">
                  {{ customerTaxInfo() }}
                </p>
                <p v-if="selectedCustomer.billing_address.address"
                   v-raw="selectedCustomer.billing_address.address"
                   class="model-info-table-cell-text" />
                <p v-if="showBillToAddress" class="model-info-table-cell-text">
                  {{ displayAddress(selectedCustomer.billing_address.zip_code,
                                    selectedCustomer.billing_address.city,
                                    selectedCustomer.billing_address.country) }}
                </p>
                <p v-if="selectedCustomer.billing_address.phone_number"
                   class="model-info-table-cell-text">
                  {{ selectedCustomer.billing_address.phone_number }}
                </p>
                <p v-if="selectedCustomer.billing_address.attention"
                   class="model-info-table-cell-text">
                  Attention: {{ selectedCustomer.billing_address.attention }}
                </p>
              </div>
              <div v-if="customerHasShippingInfo" class="model-info-table-cell col-24 col-md-12">
                <h4 class="model-info-table-cell-title">
                  SHIPPING ADDRESS
                </h4>
                <h4 class="model-info-table-cell-subtitle">
                  {{ selectedCustomer.display_name }}
                </h4>
                <p class="model-info-table-cell-text model-info-table-cell-text-normal">
                  {{ customerTaxInfo() }}
                </p>
                <p v-if="selectedCustomer.shipping_address.address"
                   v-raw="selectedCustomer.shipping_address.address"
                   class="model-info-table-cell-text" />
                <p v-if="showShipToAddress" class="model-info-table-cell-text">
                  {{ displayAddress(selectedCustomer.shipping_address.zip_code,
                                    selectedCustomer.shipping_address.city,
                                    selectedCustomer.shipping_address.country) }}
                </p>
                <p v-if="selectedCustomer.shipping_address.phone_number"
                   class="model-info-table-cell-text">
                  {{ selectedCustomer.shipping_address.phone_number }}
                </p>
                <p v-if="selectedCustomer.shipping_address.attention"
                   class="model-info-table-cell-text">
                  Attention: {{ selectedCustomer.shipping_address.attention }}
                </p>
              </div>
              <div v-else class="customer-info-table-cell col-24 col-md-12">
                <h4 class="model-info-table-cell-title">
                  SHIPPING ADDRESS
                </h4>
                <router-link :to="{ name: 'Edit Customer', params: {
                               id: selectedCustomer.id }
                             }"
                             class="model-info-table-cell-subtitle">
                  Add new address
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <multiselect
          v-else
          id="customer-search"
          v-model="selectedCustomer"
          class="model-list-select"
          track-by="id"
          placeholder="Select Customer"
          label="display_name"
          :show-labels="false"
          :show-pointer="false"
          :options="customerOptions"
          :internal-search="false"
          :reset-after="true"
          @search-change="customerSearch"
          @select="resetCustomers">
          <template slot="singleLabel" slot-scope="props">
            <span>
              {{ props.option.display_name }}
            </span>
          </template>
          <template slot="option" slot-scope="props">
            <div class="model-list-select-option">
              <div class="model-list-select-option-start">
                <i class="demo-icon" :class="customerIcon(props.option.account_type)" />
                <div class="model-list-select-option-start-text">
                  <h3>
                    {{ customerOptionText(props.option) }}
                  </h3>
                  <div v-if="props.option.email" class="mt-2 d-block d-md-none">
                    {{ props.option.email }}
                  </div>
                </div>
              </div>
              <div class="model-list-select-option-end d-none d-md-block">
                {{ props.option.email }}
              </div>
            </div>
          </template>
          <template slot="afterList">
            <li class="multiselect__element">
              <button type="button"
                      data-toggle="modal"
                      data-target="#new-customer-modal"
                      class="multiselect__option model-list-select-new">
                <i class="demo-icon icon-user-plus" /> New Customer
              </button>
            </li>
          </template>
          <template slot="caret">
            <div class="model-list-select-icon">
              <i class="demo-icon icon-search" />
            </div>
          </template>
          <template slot="noResult">
            No results
          </template>
        </multiselect>
        <input
          :value="selectedCustomerId"
          name="invoice[customer_id]"
          type="hidden">
        <CardDivider />
        <HiddenInput
          v-model="voucherTemplate.id"
          name="invoice[voucher_template_id]" />
        <HiddenInput
          v-model="overrideOnce"
          name="invoice[override_number]" />
        <template v-if="displayedComponents.subject">
          <TextInput
            v-model="usedInvoice.subject"
            name="invoice[subject]"
            custom-label="Subject"
            placeholder="Subject"
            required />
          <CardDivider />
        </template>
        <div class="form-card-group">
          <div v-if="manualNumbering || overrideOnce"
               class="form-card-group-item col-24 col-md-12 col-lg-8">
            <div class="double-input-group">
              <div class="form-group custom-form-group">
                <label
                  class="custom-form-group-label"
                  for="invoice-prefix-number">
                  Invoice Number*
                </label>
                <div class="custom-input-group">
                  <div class="input-group custom-input-group-input">
                    <input
                      v-model="invoice.prefix"
                      type="text"
                      name="invoice[prefix]"
                      placeholder="Prefix-"
                      class="form-control custom-input">
                    <input
                      v-model="invoice.number"
                      placeholder="1"
                      name="invoice[number]"
                      type="number"
                      class="form-control custom-input">
                  </div>
                  <span class="custom-input-group-postpend">
                    <a href="#"
                       class="input-edit"
                       data-toggle="modal"
                       data-target="#numbering-scheme-modal">
                      <i class="demo-icon icon-pencil" />
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="form-card-group-item col-24 col-md-12 col-lg-8">
            <div class="double-input-group">
              <div class="form-group custom-form-group">
                <label
                  class="custom-form-group-label"
                  for="invoice-prefix-number">
                  Invoice Number*
                </label>
                <div class="custom-input-group">
                  <div class="input-group custom-input-group-input">
                    <HiddenInput
                      v-model="voucherTemplate.sequence_number.prefix"
                      name="invoice[prefix]" />
                    <HiddenInput
                      v-model="voucherTemplate.sequence_number.next_number"
                      name="invoice[number]" />
                    <input
                      v-model="voucherTemplate.sequence_number.prefix"
                      name="invoice[prefix]"
                      placeholder="Prefix-"
                      :disabled="true"
                      class="form-control custom-input">
                    <input
                      v-model="voucherTemplate.sequence_number.next_number"
                      placeholder="1"
                      name="invoice[number]"
                      :disabled="true"
                      class="form-control custom-input">
                  </div>
                  <span class="custom-input-group-postpend">
                    <a href="#"
                       class="input-edit"
                       data-toggle="modal"
                       data-target="#numbering-scheme-modal">
                      <i class="demo-icon icon-pencil" />
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="voucherTemplate.show_purchase_order_number" class="form-card-group-item col-24 col-md-12 col-lg-4">
            <TextInput
              v-model="usedInvoice.po_reference"
              name="invoice[po_reference]"
              custom-label="PO Reference" />
          </div>
          <div class="form-card-group-item col-24 col-md-12 col-lg-6">
            <DateTimePicker
              ref="invoiceDate"
              v-model="invoice.date"
              name="invoice[date]"
              date-format="d/m/Y H:i"
              label-text="Invoice Date"
              :force-utc="true"
              required />
          </div>
          <div class="form-card-group-item col-24 col-md-12 col-lg-6">
            <DateTimePicker
              ref="dueDate"
              v-model="dueDate"
              name="invoice[due_date]"
              date-format="d/m/Y H:i"
              :min-date="invoice.date"
              :force-utc="true"
              label-text="Due Date" />
          </div>
        </div>
      </CardForm>

      <CardForm
        v-if="displayedComponents.description"
        no-padding
        :resource="invoice"
        resource-name="invoice"
        section-title="Description">
        <template #header-end>
          <div class="form-card-header-end">
            <a href="#"
               class="form-card-header-end-icon"
               @click.prevent="toggleInput('description')">
              <i class="demo-icon icon-times" />
            </a>
          </div>
        </template>
        <div class="form-group custom-form-group form-wysiwyg form-wysiwyg-borderless">
          <editor v-model="usedInvoice.text_description"
                  :init="initValue"
                  name="invoice[text_description]" />
        </div>
      </CardForm>

      <CardForm
        v-if="displayedComponents.attachments"
        :resource="invoice"
        resource-name="invoice"
        section-title="Attachments">
        <template #header-end>
          <div class="form-card-header-end">
            <a href="#"
               class="form-card-header-end-icon"
               @click.prevent="toggleInput('attachments')">
              <i class="demo-icon icon-times" />
            </a>
          </div>
        </template>
        <div class="ihjoz-dropzone mb-0">
          <vue-auto-dropzone
            id="attachments"
            ref="dz"
            :options="dzOptions"
            @success="handleSuccessResponse"
            @error="handleErrorResponse"
            @removedfile="deleteFile"
            @addedfiles="disableUploader"
            @complete="enableUploader" />
          <p class="ihjoz-dropzone-help">
            Upload a PDF, JPG or PNG Invoice with a maximum size of 10MB.
          </p>
          <div class="control-group">
            <button
              id="attachments-browse"
              type="button"
              class="btn btn-outline-primary ihjoz-button">
              Browse
            </button>
          </div>
        </div>
      </CardForm>

      <CardForm
        v-if="displayedComponents.lineItems"
        no-padding
        :resource="invoice"
        resource-name="invoice"
        section-title="Line Items">
        <template #header-end>
          <div class="form-card-header-end">
            <a href="#"
               class="form-card-header-end-icon"
               @click.prevent="toggleInput('lineItems')">
              <i class="demo-icon icon-times" />
            </a>
          </div>
        </template>
        <LineItems :currencies="currencies"
                   :taxes="taxes"
                   :invoice-currency="invoice.currency_id"
                   @getPaymentPreview="getPaymentPreview"
                   @currencyChange="onLineItemCurrencyChanged" />
      </CardForm>
      <CardForm
        v-else
        :resource="invoice"
        resource-name="invoice"
        section-title="Amount">
        <template #header-end>
          <div class="form-card-header-end">
            <a href="#"
               @click.prevent="toggleInput('lineItems')">
              Switch to Line Items
            </a>
          </div>
        </template>
        <input type="hidden"
               value="false"
               name="invoice[clear_line_items]">
        <input v-model="index"
               type="hidden"
               value="0"
               :name="`invoice[line_items_attributes][0][sort_index]`">
        <input v-model="lineItem.quantity"
               type="hidden"
               value="1"
               :name="`invoice[line_items_attributes][0][quantity]`">
        <input v-model="taxRate"
               type="hidden"
               value="1"
               :name="`invoice[line_items_attributes][0][tax_rate]`">
        <input v-model="taxName"
               type="hidden"
               :name="`invoice[line_items_attributes][0][tax_name]`">
        <input v-model="amount"
               type="hidden"
               :name="`invoice[line_items_attributes][0][amount]`">
        <input v-model="totalAmount"
               type="hidden"
               :name="`invoice[line_items_attributes][0][total_amount]`">
        <input v-model="taxAmount"
               type="hidden"
               :name="`invoice[line_items_attributes][0][tax_amount]`">
        <input v-model="invoice.currency_id"
               type="hidden"
               :name="`invoice[line_items_attributes][0][currency_id]`">
        <input v-model="selectedTaxId"
               type="hidden"
               :name="`invoice[line_items_attributes][0][tax_id]`">
        <div class="invoice-form-total">
          <div class="invoice-form-total-text col-24 col-md-8 mb-3 mb-md-0">
            <h2 class="invoice-form-total-text-title">
              SUBTOTAL
            </h2>
            <p class="invoice-form-total-text-subtitle">
              Excluding Taxes
            </p>
          </div>
          <div class="invoice-form-total-input col-24 mb-md-0"
               :class="{ 'col-md-16': !showTaxesDropdown, 'col-md-8 mb-3': showTaxesDropdown }">
            <div class="custom-input-group">
              <div class="input-group custom-input-group-input">
                <currency-input v-model="invoiceAmount"
                                type="text"
                                class="form-control custom-input-group-input-field"
                                :currency="null"
                                :distraction-free="false"
                                :precision="currencyPrecision"
                                required="true"
                                @input="getPaymentPreview" />
                <input v-model="invoiceAmount"
                       type="hidden"
                       required="true"
                       :name="`invoice[line_items_attributes][0][price]`">
                <div class="input-group-prepend custom-input-group-input-select">
                  <select
                    id="invoice-currency"
                    v-model="invoice.currency_id"
                    name="invoice[currency_id]"
                    class="custom-select custom-input"
                    @change="onChange($event)">
                    <option
                      v-for="(currency) in currencies"
                      :key="currency.id"
                      :value="currency.id">
                      {{ currency.iso_code }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div v-show="showTaxesDropdown" class="invoice-form-total-input-select col-24 col-md-8">
            <ItemSelect
              v-model="selectedTaxId"
              :items="mappedTaxes"
              :shortened="false"
              key-method="name"
              value-method="id"
              :display-label="false"
              @change="getPaymentPreview" />
          </div>
        </div>
        <CardDivider />
        <div class="line-items-footer mb-0">
          <div class="line-items-footer-item
            line-items-footer-item-first
            line-items-footer-item-highlighted px-i">
            <div class="line-items-footer-item-start">
              SUBTOTAL
            </div>
            <div class="line-items-footer-item-end footer-item-subtotal-amount-js">
              {{ invoiceAmount | formatCurrency(selectedCurrency.iso_code) }}
            </div>
          </div>
          <div v-if="vatAmount" class="line-items-footer-item px-i">
            <div class="line-items-footer-item-start">
              {{ taxDisplay }}
            </div>
            <div class="line-items-footer-item-end footer-item-subtotal-amount-js">
              {{ vatAmount | formatCurrency(selectedCurrency.iso_code) }}
            </div>
          </div>
          <div class="line-items-footer-item
            line-items-footer-item-highlighted line-items-footer-item-last px-i">
            <div class="line-items-footer-item-start">
              TOTAL
            </div>

            <div class="line-items-footer-item-end footer-item-total-amount-js">
              {{ invoiceTotal | formatCurrency(selectedCurrency.iso_code) }}
              <input v-model="invoiceTotal"
                     type="hidden"
                     required="true"
                     name="invoice[total]">
            </div>
          </div>
        </div>
      </CardForm>

      <CardForm
        v-if="displayedComponents.notes"
        no-padding
        :resource="invoice"
        resource-name="invoice"
        section-title="Notes">
        <template #header-end>
          <div class="form-card-header-end">
            <a href="#"
               class="form-card-header-end-icon"
               @click.prevent="toggleInput('notes')">
              <i class="demo-icon icon-times" />
            </a>
          </div>
        </template>
        <div class="form-group custom-form-group form-wysiwyg form-wysiwyg-borderless">
          <editor v-model="usedInvoice.notes"
                  :init="initValue"
                  name="invoice[notes]" />
        </div>
      </CardForm>
      <CardForm
        v-if="displayedComponents.conditions"
        no-padding
        :resource="invoice"
        resource-name="invoice"
        section-title="Terms of Service">
        <template #header-end>
          <div class="form-card-header-end">
            <a href="#"
               class="form-card-header-end-icon"
               @click.prevent="toggleInput('conditions')">
              <i class="demo-icon icon-times" />
            </a>
          </div>
        </template>
        <div class="form-group custom-form-group form-wysiwyg form-wysiwyg-borderless">
          <editor v-model="usedInvoice.conditions"
                  :init="initValue"
                  name="invoice[conditions]" />
        </div>
      </CardForm>

      <div v-if="paymentMethods" class="flip-card card">
        <div class="flip-card-header
        flip-card-header-wrappable
        flip-card-header-has-footer px-i"
             :class="{'flip-card-header-closed': !opened}">
          <div class="flip-card-header-title">
            <h3 class="flip-card-header-title-text">
              Payment Settings
            </h3>
            <h4 class="flip-card-header-title-subtext">
              No fees are charged for transactions paid directly to you.
            </h4>
          </div>
          <a class="btn btn-primary ihjoz-button"
             aria-expanded="false"
             data-toggle="collapse"
             href="#payment-settings"
             @click="flipOpened()">
            Edit Payment Settings
          </a>
        </div>
        <div id="payment-settings" class="flip-card-body collapse">
          <div class="invoice-payment-settings">
            <div class="invoice-payment-settings-section px-i">
              <h3>
                Service Charge
              </h3>
              <div class="invoice-payment-settings-wrapper">
                <div class="settings-row settings-row-bordered">
                  <div class="settings-row-cell settings-row-cell-label col-24 col-lg-8 px-i">
                    <h3 class="settings-row-cell-title">
                      {{ usedInvoiceFee.name }}
                    </h3>
                    <div v-if="invoicingFee && !fetchingPaymentPreviews">
                      {{ invoicingFee | formatCurrency(selectedCurrency.iso_code) }}
                    </div>
                  </div>
                  <div class="settings-row-cell col-24 col-lg-6 px-i d-none d-lg-block" />
                  <div class="settings-row-cell col-24 col-lg-4 px-i d-none d-lg-block" />
                  <div class="settings-row-cell col-24 col-lg-6 px-i">
                    <RadioControlWrapper
                      :wrappable="true">
                      <BoolRadioControl
                        :v-model="`fee_settings[invoice_fee][absorb_payment_fee]`"
                        name="invoice[fee_settings[invoice_fee][absorb_payment_fee]]"
                        label="Absorb Fee"
                        default-checked
                        :used-value="true"
                        @change="getPaymentPreview" />
                      <BoolRadioControl
                        :v-model="`fee_settings[invoice_fee][absorb_payment_fee]`"
                        name="invoice[fee_settings[invoice_fee][absorb_payment_fee]]"
                        label="Pass on Fee"
                        :used-value="false"
                        @change="getPaymentPreview" />
                    </RadioControlWrapper>
                  </div>
                </div>
              </div>
            </div>
            <div class="invoice-payment-settings-section px-i">
              <h3>
                Payment Fees
              </h3>
              <div v-if="paymentMethods.length === 0">
                <input :v-model="`invoice[payment_settings][0]`"
                       type="hidden"
                       value=""
                       name="invoice[payment_settings][0]">
              </div>
              <div v-else class="invoice-payment-settings-wrapper">
                <div v-for="paymentMethod in paymentMethods"
                     :key="paymentMethod.id"
                     class="settings-row settings-row-bordered">
                  <div class="settings-row-cell settings-row-cell-label col-24 col-lg-8 px-i">
                    <h3 class="settings-row-cell-title">
                      {{ paymentMethod.title.en }}
                    </h3>
                    <div v-if="displayFees(paymentMethod.id) && !fetchingPaymentPreviews">
                      {{ displayFees(paymentMethod.id) | formatCurrency(selectedCurrency.iso_code) }}
                    </div>
                  </div>
                  <div class="settings-row-cell col-24 col-lg-6 px-i"
                       :class="{ 'py-0': !paymentMethod.payment_method_badges.length }">
                    <div v-for="paymentBadge in paymentMethod.payment_method_badges"
                         :key="paymentBadge.id"
                         class="payment-method-badge">
                      <img v-if="paymentBadge.image.url"
                           class="payment-method-badge-image"
                           :src="paymentBadge.image.url">
                    </div>
                  </div>
                  <div class="settings-row-cell col-24 col-lg-4 px-i">
                    <ToggleButton
                      :v-model="`payment_settings[${paymentMethod.id}][enabled]`"
                      :name="`invoice[payment_settings[${paymentMethod.id}][enabled]]`"
                      :checked="isPaymentMethodEnabled(paymentMethod.id)"
                      :default-checked="true" />
                  </div>
                  <div class="settings-row-cell col-24 col-lg-6 px-i">
                    <RadioControlWrapper
                      :wrappable="true">
                      <BoolRadioControl
                        :v-model="`payment_settings[${paymentMethod.id}][absorb_payment_fee]`"
                        :name="`invoice[payment_settings[${paymentMethod.id}][absorb_payment_fee]]`"
                        label="Absorb Fee"
                        default-checked
                        :used-value="true"
                        :value="isPaymentMethodAbsorbed(paymentMethod.id)"
                        @change="getPaymentPreview" />
                      <BoolRadioControl
                        :v-model="`payment_settings[${paymentMethod.id}][absorb_payment_fee]`"
                        :name="`invoice[payment_settings[${paymentMethod.id}][absorb_payment_fee]]`"
                        label="Pass on Fee"
                        :value="isPaymentMethodAbsorbed(paymentMethod.id)"
                        :used-value="false"
                        @change="getPaymentPreview" />
                    </RadioControlWrapper>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flip-card-footer">
          <div class="invoice-payment-preview">
            <div class="invoice-payment-preview-section col-24 col-lg-8 px-i">
              <h3 class="invoice-payment-preview-section-label">
                Amount Due
              </h3>
              <template v-if="fetchingPaymentPreviews">
                <div class="invoice-payment-preview-section-amount">
                  <div class="
                  lds-ring lds-ring-primary invoice-payment-preview-section-amount-spinner">
                    <div />
                    <div />
                    <div />
                    <div />
                  </div>
                </div>
              </template>
              <template v-else>
                <div v-if="displayedComponents.lineItems" class="invoice-payment-preview-section-amount">
                  {{ lineItemsTotal | formatCurrency(selectedCurrency.iso_code) }}
                </div>
                <div v-else class="invoice-payment-preview-section-amount">
                  {{ invoiceTotal | formatCurrency(selectedCurrency.iso_code) }}
                </div>
              </template>
            </div>
            <div class="invoice-payment-preview-section col-24 col-lg-8 px-i">
              <h3 class="invoice-payment-preview-section-label">
                Customer Pays *
              </h3>
              <div class="invoice-payment-preview-section-amount">
                <template v-if="fetchingPaymentPreviews">
                  <div class="
                  lds-ring lds-ring-primary invoice-payment-preview-section-amount-spinner">
                    <div />
                    <div />
                    <div />
                    <div />
                  </div>
                </template>
                <template v-else>
                  {{ minimumCustomerPays | formatCurrency(selectedCurrency.iso_code) }}
                </template>
              </div>
            </div>
            <div class="invoice-payment-preview-section col-24 col-lg-8 px-i">
              <h3 class="invoice-payment-preview-section-label">
                You Receive *
              </h3>
              <div class="invoice-payment-preview-section-amount">
                <template v-if="fetchingPaymentPreviews">
                  <div class="
                  lds-ring lds-ring-primary invoice-payment-preview-section-amount-spinner">
                    <div />
                    <div />
                    <div />
                    <div />
                  </div>
                </template>
                <template v-else>
                  {{ merchantPayout | formatCurrency(selectedCurrency.iso_code) }}
                </template>
              </div>
            </div>
          </div>
          <div class="flip-card-footer-disclaimer px-i">
            * Minimum amount. Fees may vary according to selected payment methods.
          </div>
        </div>
      </div>
    </FormCard>
    <div id="numbering-scheme-modal"
         class="modal fade"
         tabindex="-1"
         role="dialog"
         aria-labelledby="numbering-scheme-modal-label"
         aria-hidden="true">
      <form id="cancel-form" class="modal-dialog custom-modal">
        <div class="modal-content">
          <div class="modal-header custom-modal-header px-i">
            <div class="custom-modal-header-start">
              <h4 class="modal-title custom-modal-header-start-title">
                Invoice Number
              </h4>
            </div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div v-if="manualNumbering" class="modal-body custom-modal-body px-i">
            Your Invoice numbers are set to “Manual Input”.

            Would you like to change your template settings to generate them automatically ?
          </div>
          <div v-else class="modal-body">
            Your invoice numbers are set to "Autogenerate". You can change your numbering sequence
            and settings in your invoice template or override this invoice number manually.
          </div>
          <div class="modal-footer custom-modal-footer custom-modal-footer-wrap px-i">
            <button type="button"
                    data-dismiss="modal"
                    class="btn btn-outline-primary ihjoz-button ihjoz-button-mobile-stacked">
              Cancel
            </button>
            <router-link :to="{ name: 'Edit Template', params: {
                           id: voucherTemplate.id } }"
                         type="button"
                         class="btn btn-primary ihjoz-button ihjoz-button-mobile-stacked"
                         data-dismiss="modal">
              Invoice Template
            </router-link>
            <button v-show="!manualNumbering && (!overrideOnce || !manualNumbering)"
                    type="button"
                    class="btn btn-primary ihjoz-button ihjoz-button-mobile-stacked"
                    @click="overrideNumberingOnce($event)">
              {{ overrideText }}
            </button>
          </div>
        </div>
      </form>
    </div>
    <CustomerModalForm @newCustomer="addNewCustomer($event)" />
    <InvoicePreviewModal v-if="invoicePreviewBuilt"
                         :invoice="usedInvoice"
                         :due-date="dueDate"
                         :invoice-date="invoice.date"
                         :invoice-currency="selectedCurrency"
                         :customer-total="totalAmount"
                         :merchant-invoice-number="invoiceNumber"
                         :vat-amount="vatAmount"
                         :document-title="voucherTemplate.document_title"
                         :selected-tax="selectedTax"
                         :merchant="currentMerchant"
                         :customer="selectedCustomer"
                         :displayed-components="displayedComponents"
                         :invoice-attachment="invoiceAttachment"
                         :invoice-subtotal="invoiceAmount" />
  </div>
</template>

<script>
import FormCard from "@shared/components/UI/FormCard.vue";
import CardForm from "@shared/components/UI/CardForm.vue";
import Multiselect from "vue-multiselect";
import CardDivider from "@shared/components/UI/CardDivider.vue";
import TextInput from "@shared/components/UI/TextInput.vue";
import DateTimePicker from "@shared/components/UI/DateTimePicker.vue";
import RadioControlWrapper from "@shared/components/UI/RadioControlWrapper.vue";
import BoolRadioControl from "@shared/components/UI/BoolRadioControl.vue";
import ToggleButton from "@shared/components/UI/ToggleButton.vue";
import ItemSelect from "@shared/components/UI/ItemSelect.vue";
import VueAutoDropzone from "vue-auto-dropzone";
import Editor from "@tinymce/tinymce-vue";
import NotificationsMixin from "@shared/Mixins/NotificationsMixin";
import PaymentMethodStore from "@tenant_admin/stores/PaymentMethodStore";
import CompanyStore from "@shared/components/Company/CompanyStore";
import createSearchRegexp from "@shared/createSearchRegexp";
import CustomerModalForm from "../../Customer/CustomerModalForm.vue";
import InvoicePreviewModal from "../InvoicePreviewModal.vue";
import LineItems from "./LineItems.vue";
import FilePDFSVG from "@assets/images/file-pdf.svg";

import { mapActions, mapGetters, mapMutations } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
  name: "InvoiceForm",

  components: {
    FormCard,
    CardForm,
    CardDivider,
    TextInput,
    DateTimePicker,
    RadioControlWrapper,
    BoolRadioControl,
    ToggleButton,
    ItemSelect,
    Multiselect,
    VueAutoDropzone,
    Editor,
    CustomerModalForm,
    InvoicePreviewModal,
    LineItems
  },

  mixins: [NotificationsMixin],

  props: {
    invoice: { type: Object },
    customer: { type: Object, default: null },
    currencyTenants: { type: Array, default: () => [] },
    invoiceFees: { type: Array, default: () => [] },
    customers: { type: Array, default: () => [] },
    voucherTemplate: { type: Object },
    displayedComponents: { type: Object },
    selectedInvoiceFee: { type: Object },
    invoicePreviewBuilt: { type: Boolean, default: false }
  },

  data () {
    return {
      customersData: this.customers,
      customerOptions: this.customers,
      selectedCustomer: this.customer,
      opened: false,
      invoiceResourceId: this.invoice.invoice_resource.id,
      invoiceAttachment: [],
      vatAmount: 0,
      index: 0,
      selectedTaxId: "",
      dueDate: "",
      invoiceTotal: this.invoice.total,
      createAndSend: true,
      paymentMethods: [],
      overrideOnce: false,
      overrideText: "Override Once",
      invoiceAmount: this.invoice.amount,
      paymentPreviews: {},
      fetchingPaymentPreviews: false,
      lineItem: { quantity: 1, price: this.invoice.amount },
      initValue: {
        theme: "silver",
        skin: false,
        language: this.$i18n.locale,
        branding: false,
        images_upload_url: "/api/v4/upload_image",
        paste_data_images: true,
        relative_urls: false,
        content_css: Dashboard.stylesheetPath,
        toolbar: "insertfile undo redo | styleselect fontselect fontsizeselect | bold italic underline strikethrough | ltr rtl alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link anchor image media | preview code fullscreen | forecolor backcolor removeformat| pagebreak | charmap table |",
        toolbar_drawer: "sliding",
        plugins: ["lists", "advlist", "paste", "link", "autoresize", "image", "imagetools", "preview", "code", "table", "pagebreak", "charmap", "directionality", "anchor", "media"],
        image_advtab: true,
        imagetools_cors_hosts:
        ["images-qa-ihjoz-com.s3.amazonaws.com", "images-ihjoz-com.s3.amazonaws.com"],
        fontsize_formats: "10px 12px 14px 16px 18px 24px 36px 48px",
        font_formats: "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats;Open Sans=Open Sans, Helvetica, Tahoma, sans-serif"
      }
    };
  },

  computed: {
    ...mapGetters("lineItems", {
      isOneEmptyLineItemLeft: "isOneEmptyLineItemLeft",
      lineItemsTotal: "totalAmount",
      showTaxesDropdown: "showTaxesDropdown"
    }),

    ...mapFields("lineItems", [
      "lineItems"
    ]),

    ...mapFields("instruments", [
      "taxes"
    ]),

    usedInvoice () {
      return this.invoice;
    },

    usedInvoiceFee: {
      get: function () {
        return this.selectedInvoiceFee;
      },

      set: function (newVal) {
        return newVal;
      }
    },

    submitButtonName () {
      return this.invoice.id ? "Update" : "Send";
    },

    taxName () {
      return this.selectedTax.name;
    },

    amount () {
      return this.invoiceAmount * this.lineItem.quantity;
    },

    taxAmount () {
      return this.invoiceAmount * this.taxRate / 100;
    },

    totalAmount () {
      return this.invoiceAmount + this.taxAmount;
    },

    taxRate () {
      return this.selectedTax.rate;
    },

    defaultTax () {
      return this.taxes.length ? this.taxes[0].id : "";
    },

    selectedCurrencyId: {
      get: function () {
        if (this.invoice.currency_id) {
          return this.invoice.currency_id;
        } else {
          return this.voucherTemplate.merchant_base_currency.id;
        };
      },

      set: function (newValue) {
        this.invoice.currency_id = newValue;
        this.buildSimpleLineItem();
      }
    },

    selectedCurrency: {
      get: function () {
        return this.filter_currency_by_id(this.selectedCurrencyId);
      },

      set: function (newCurrency) {
        return newCurrency;
      }
    },

    invoicePrefix: {
      get: function () {
        return this.invoice.prefix || this.voucherTemplate.invoice_number_prefix;
      },

      set: function (newValue) {
        this.invoice.prefix = newValue;
      }
    },

    currentMerchant () {
      return CompanyStore.currentCompany;
    },

    invoiceNumber () {
      if (!this.overrideOnce && !this.manualNumbering) {
        return this.voucherTemplate.sequence_number.prefix +
        this.voucherTemplate.sequence_number.next_number;
      } else {
        return this.invoicePrefix + this.invoice.number;
      }
    },

    mappedTaxes () {
      return this.taxes.map(
        tax => ({ id: tax.id, name: `${tax.name.toUpperCase()} (${tax.rate}%)` }));
    },

    selectedTax () {
      return this.taxes.find(tax => tax.id.toString() === this.selectedTaxId.toString());
    },

    taxDisplay () {
      return `${this.selectedTax.name.toUpperCase()} (${this.selectedTax.rate}%)`;
    },

    currencies () {
      return this.$_.uniq(
        this.currencyTenants.map(currencyTenant => currencyTenant.currency), "id");
    },

    selectedCustomerId () {
      if (this.selectedCustomer) {
        return this.selectedCustomer.id;
      } else {
        return null;
      }
    },

    dzOptions () {
      var self = this;
      return {
        url: this.dzURL,
        method: this.dzMethod,
        uploadMultiple: true,
        parallelUploads: 5,
        paramName: "invoice_resource",
        addRemoveLinks: true,
        clickable: ["#attachments", "#attachments-browse"],
        renameFile: function (file) {
          return file.name.replace(/[^\w.]/gi, "_");
        },
        init: function () {
          if (self.invoice.description.files) {
            for (let i = 0; i < self.invoice.description.files.length; i++) {
              let file = self.invoice.description.files[i];
              let ext = file.original.split(".").pop();
              let mockFile = { name: file.original.split("/").slice(-1)[0], size: file.size };
              let thumbnail;

              if (ext === "pdf") {
                thumbnail = FilePDFSVG;
              } else {
                thumbnail = file.original;
              }

              this.displayExistingFile(mockFile, thumbnail, null, null, false);
            }
          }
        }
      };
    },

    dzURL () {
      if (this.invoiceResourceId) {
        return `/api/v4/invoice_resources/${this.invoiceResourceId}`;
      } else {
        return "/api/v4/invoice_resources";
      }
    },

    dzMethod () {
      if (this.invoiceResourceId) {
        return "put";
      } else {
        return "post";
      }
    },

    currencyPrecision () {
      return this.selectedCurrency.iso_code === "LBP" ? 0 : 2;
    },

    showBillToAddress () {
      return this.selectedCustomer.billing_address.city ||
      this.selectedCustomer.billing_address.country;
    },

    showShipToAddress () {
      return this.selectedCustomer.shipping_address.city ||
      this.selectedCustomer.shipping_address.country;
    },

    customerHasShippingInfo () {
      return this.selectedCustomer.shipping_address.address ||
             this.showShipToAddress ||
             this.selectedCustomer.shipping_address.phone_number ||
             this.selectedCustomer.shipping_address.attention;
    },

    invoicingFee () {
      return this.paymentPreviews.invoicing_fee;
    },

    minimumCustomerPays () {
      return this.paymentPreviews.customer_pays ? this.paymentPreviews.customer_pays : 0;
    },

    merchantPayout () {
      return this.paymentPreviews.merchant_payout ? this.paymentPreviews.merchant_payout : 0;
    },

    manualNumbering () {
      return this.voucherTemplate.manual_numbering;
    }
  },

  watch: {
    "invoice.date": function (newVal, _) {
      this.$refs.invoiceDate.updateDate();
      if (!this.invoice.due_date) {
        this.refreshDueDate(newVal);
      }
    },

    "selectedTaxId": function (newVal, _) {
      this.vatAmount = this.calculateVatAmount(this.invoiceAmount);
      this.invoiceTotal = this.vatAmount + this.invoiceAmount;
      this.buildSimpleLineItem();
    },

    "invoiceAmount": function (newVal, _) {
      this.vatAmount = this.calculateVatAmount(newVal);
      this.invoiceTotal = this.vatAmount + newVal;
      this.buildSimpleLineItem();
    },

    "displayedComponents.attachments": function (newVal, _) {
      if (!newVal) {
        this.invoiceResourceId = null;
      }
    }
  },

  created () {
    this.selectedTaxId = this.defaultTax;
    this.dueDate = this.initializeDueDate(this.invoice.date);
    this.getPaymentPreview = this.$_.debounce(async () => {
      if (this.lineItemsTotal || this.invoiceTotal) {
        this.fetchingPaymentPreviews = true;
        let data = new FormData(document.getElementById("form-card"));

        let response = await fetch("/api/v4/invoices/payment_preview", {
          body: data,
          method: "POST"
        });

        let responseJSON = await response.json();

        this.fetchingPaymentPreviews = false;

        if (responseJSON.success) {
          this.paymentPreviews = responseJSON.body;
        } else {
          this.paymentPreviews = {};
          this.notifyError("Something went wrong. Please try again.");
        }
      } else {
        this.paymentPreviews = {};
      }
    }, 250);
  },

  mounted () {
    this.setInvoiceResourceId(this.invoice.invoice_resource.id);
    this.usedInvoiceFee = this.invoiceFees.filter(
      fee => fee.currency_id === this.voucherTemplate.merchant_base_currency.id)[0];
    this.fetchPaymentMethods();
  },

  methods: {
    ...mapActions("lineItems", [
      "addNewLineItem",
      "updateLineItems"
    ]),

    ...mapMutations("lineItems", [
      "removeEmptyLineItems",
      "resetState"
    ]),

    buildSimpleLineItem () {
      if (!this.displayedComponents.lineItems) {
        this.resetState();
        let result = [{
          amount: this.invoiceAmount,
          currency: this.selectedCurrency,
          discountedAmount: this.invoiceAmount,
          name: null,
          price: this.invoiceAmount,
          quantity: 1,
          removed: false,
          tax: this.selectedTax,
          tax_id: parseInt(this.selectedTaxId),
          tax_rate: this.taxRate,
          tax_name: this.taxName,
          tax_amount: this.vatAmount,
          total_amount: this.totalAmount
        }];
        this.updateLineItems(result);
      }
    },

    confirm: function (e) {
      if (window.confirm("Are you sure you want to discard your changes?")) {
        this.$router.back();
      } else {
        e.preventDefault();
      }
    },

    filter_currency_by_id (currencyId) {
      return this.currencies.filter(currency => currency.id === currencyId)[0];
    },

    submitClicked (e) {
      this.removeEmptyLineItems();
    },

    onChange (event) {
      let currencyId = parseInt(
        event.target.options[event.target.options.selectedIndex].value);
      this.invoice.currency_id = currencyId;
      this.selectedCurrencyId = currencyId;
      this.$emit("updateSelectedInvoiceFee", event.target.value);
      this.usedInvoiceFee = this.invoiceFees.filter(
        fee => fee.currency_id.toString() === event.target.value)[0];
      this.fetchPaymentMethods();
    },

    isPaymentMethodEnabled (paymentMethodId) {
      if (this.invoice.payment_settings && this.invoice.payment_settings[paymentMethodId]) {
        return this.invoice.payment_settings[paymentMethodId]["enabled"] === "true";
      } else if (this.invoice.id) {
        return false;
      } else {
        return true;
      }
    },

    isPaymentMethodAbsorbed (paymentMethodId) {
      if (this.invoice.payment_settings && this.invoice.payment_settings[paymentMethodId]) {
        return this.invoice.payment_settings[paymentMethodId]["absorb_payment_fee"] === "true";
      } else {
        return false;
      }
    },

    toggleCreateAndSend (e) {
      this.createAndSend = false;
      this.submitForm(e);
    },

    submitForm (e) {
      if (this.createAndSend) {
        this.$refs.invoiceStatus.value = "outstanding";
      } else {
        this.$refs.invoiceStatus.value = "draft";
      }

      this.$emit("formSubmit", e);
    },

    onLineItemCurrencyChanged (event) {
      this.onChange(event);
    },

    initializeDueDate (newValue) {
      if (this.invoice.due_date) {
        return this.invoice.due_date;
      } else {
        return this.calculateDueDate(newValue);
      }
    },

    calculateDueDate (newValue) {
      let defaultDueDate = this.voucherTemplate.default_due_date_option;

      if (defaultDueDate === "on_receipt") {
        defaultDueDate = "0";
      }

      return this.$dayjs(newValue).add(
        parseInt(defaultDueDate), "days").toISOString();
    },

    refreshDueDate (newVal) {
      this.dueDate = this.calculateDueDate(newVal);
      this.$refs.dueDate.updateDate();
    },

    overrideNumberingOnce () {
      this.overrideOnce = !this.overrideOnce;
      if (this.overrideOnce) {
        this.overrideText = "Autogenerate";
      } else {
        this.overrideText = "Override Once";
      }
      $("#numbering-scheme-modal").modal("hide");
    },

    calculateVatAmount (invoiceAmount) {
      let taxRate;
      if (this.selectedTaxId) {
        taxRate = this.selectedTax.rate;
      } else {
        taxRate = 0.0;
      }
      return taxRate * invoiceAmount / 100;
    },

    setInvoiceResourceId (id) {
      if (id) {
        this.invoiceResourceId = id;
      }
    },

    handleSuccessResponse (file, response) {
      this.updateInvoiceResourceId(response);
      this.updateFileObject(response);
      this.notifySuccess(response.successMessage);
    },

    updateFileObject (response) {
      let files = [];
      response.invoice_resource.files.forEach(function (file) {
        files.push({ display: file.display_image["url"], original: file["url"] });
      });
      this.invoiceAttachment = files;
    },

    removeFileObject (files, fileOriginal) {
      return files.filter((item) => item.original !== fileOriginal);
    },

    updateInvoiceResourceId (response) {
      this.setInvoiceResourceId(response.invoice_resource.id);
      this.$refs.dz.setOptions({ url: this.dzURL, method: this.dzMethod });

      if (!this.invoice.id) {
        this.$emit("formChanged", true);
      }
    },

    handleErrorResponse (file, response) {
      this.notifyError(response);
    },

    async deleteFile (file) {
      let fileName = file.name.replace(/[^\w.]/gi, "_");
      let response = await fetch(
        `${this.dzURL}/delete_file?file_name=${fileName}`,
        {
          method: "put"
        }
      );

      let responseJSON = await response.json();
      let removedFileOriginal =
      `/uploads/invoice_resources/files/${this.invoiceResourceId}/${fileName}`;
      if (responseJSON.success) {
        this.invoiceAttachment = this.removeFileObject(this.invoiceAttachment, removedFileOriginal);
        this.notifySuccess(responseJSON.successMessage);
      }
    },

    disableUploader (files) {
      this.$refs.dz.removeEventListeners();
    },

    enableUploader (file) {
      this.$refs.dz.setupEventListeners();
    },

    async fetchPaymentMethods () {
      this.paymentMethodsCollection = await PaymentMethodStore.methods.filter(
        this.currentMerchant.country.id,
        this.invoice.currency_id,
        Dashboard.currentTenant.id
      );

      this.paymentMethods = this.$_.orderBy(
        this.paymentMethodsCollection.payment_methods, "visual_order_number");
      this.getPaymentPreview();
    },

    displayFees (id) {
      if (this.paymentPreviews.fees) {
        return this.paymentPreviews.fees[id];
      }
    },

    flipOpened () {
      this.opened = !this.opened;
    },

    toggleInput (field) {
      this.$emit("displayChanged", field);
    },

    customerIcon (type) {
      if (type === "Individual") {
        return "icon-user";
      } else {
        return "icon-building";
      }
    },

    customerOptionText (customer) {
      if (customer.account_type === "Individual") {
        return customer.display_name;
      } else {
        return `${customer.display_name} - ${customer.first_name} ${customer.last_name}`;
      }
    },

    customerSearch (query) {
      let searchRegexp = createSearchRegexp(query, false, true, true);

      this.customerOptions = this.customersData.filter((customer) => {
        return searchRegexp.test(
          customer.display_name + customer.company_name + customer.email + customer.mobile_number);
      });
    },

    displayAddress (zip, city, country) {
      if (city && country) {
        return `${zip} ${city}, ${country}`.trim();
      } else {
        return `${zip} ${city}${country}`.trim();
      }
    },

    customerTaxInfo () {
      let { tax_type: taxType = "", tax_number: taxNumber = "" } = this.selectedCustomer;

      if (taxType === null) {
        taxType = "";
      }

      if (taxNumber === null) {
        taxNumber = "";
      }

      return `${taxType} ${taxNumber}`.trim();
    },

    clearSelectedCustomer () {
      this.selectedCustomer = null;
    },

    resetCustomers (selectedOption, id) {
      this.customerOptions = this.customers;
    },

    addNewCustomer (e) {
      this.customersData.push(e);
      this.selectedCustomer = e;
    }
  }
};
</script>
